// extracted by mini-css-extract-plugin
export default {"StatusIcon":"LawStatusIcon_StatusIcon__Ykxrj","NoStatus":"LawStatusIcon_NoStatus__nEfAw"};